import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextField, Box, Button } from '@mui/material';
import { getWinnersReport } from '../../../services/api/customerReportApi';
import { downloadCSV } from '../../../services/downloadUtils';
import {
    hideLoading,
    showLoading,
} from '../../../store/actions/loadingActions';
import {
    notifyError,
    notify,
} from '../../../store/actions/notificationActions';

const WinnersReport = () => {
    const dispatch = useDispatch();
    const { auth } = useSelector((state) => state);
    const { market, category, brand } = auth.user;
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [formError, setFormError] = useState('');

    const handleCancel = () => {
        setStartDate(null);
        setEndDate(null);
    };

    const handleDownload = async () => {
        setFormError('');
        if (!startDate || !endDate) {
            setFormError('Please select both start and end dates.');
            return;
        }
        if (startDate > endDate) {
            setFormError('Start date cannot be after end date.');
            return;
        }

        try {
            dispatch(showLoading());
            const response = await getWinnersReport(
                market,
                category,
                brand,
                dayjs(startDate).startOf('day').toISOString(),
                dayjs(endDate).endOf('day').toISOString()
            );

            if (response.trim()) {
                downloadCSV(response, 'Golden-Winners.csv');
            } else {
                dispatch(notify('No records to download'));
            }
        } catch (error) {
            dispatch(notifyError('Error!', 'Unable to fetch report'));
        } finally {
            dispatch(hideLoading());
        }
    };

    return (
        <div className="customer-report-child">
            <h3 className="customer-report-child-title">
                Please select valid date to download the winners report.
            </h3>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                <DatePicker
                    label={<Box color={'#000'}>From</Box>}
                    value={startDate}
                    onChange={(date) => setStartDate(date)}
                />
                <DatePicker
                    label={<Box color={'#000'}>To</Box>}
                    value={endDate}
                    onChange={(date) => setEndDate(date)}
                    minDate={startDate}
                    renderInput={(params) => <TextField {...params} />}
                />
            </Box>
            {formError && (
                <p className="customer-report-child-error">{formError}</p>
            )}
            <p className="customer-report-child-note">
                Download format will be .csv
            </p>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                <Button variant="outlined" onClick={handleCancel}>
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    onClick={handleDownload}
                    disabled={!startDate || !endDate || startDate > endDate}
                >
                    Download
                </Button>
            </Box>
        </div>
    );
};

export default WinnersReport;
